export default "__VITE_ASSET__B6epln_0__"